import {isRequestedFromGoogleProxy} from '@gfiber/pixel-party';

export function getOpenApiBaseUrl() {
  if (isRequestedFromGoogleProxy()) {
    return process.env.NEXT_PUBLIC_OPEN_API_PROXY_PATH;
  }

  if (
    process.env.TARGET_ENV === 'prod' ||
    process.env.TARGET_ENV === 'test' ||
    process.env.TARGET_ENV === 'staging'
  ) {
    return process.env.NEXT_PUBLIC_OPEN_API_SECURE_API;
  }
  if (process.env.TARGET_ENV === 'dev') {
    return 'https://api.dev.gfiber.com/v1/cxe';
  }
  // Set this arbitration path with 'openapi' prefix.
  // 'openapi' is used for LB and local caddy proxy redirection.
  // If you still want to access buyflow via https://localhost:3002,
  // update below path to "https://api.dev.gfiber.com/v1/cxe" directly.
  return '/openapi/v1/cxe';
}

export function getOpenApiNutritionLabelBaseUrl() {
  if (isRequestedFromGoogleProxy()) {
    return process.env.NEXT_PUBLIC_OPEN_API_NON_SECURE_PROXY_PATH;
  }

  return process.env.NEXT_PUBLIC_NUTRITION_LABEL_API;
}
